import request from '../utils/request'

/**
 * 获取会员列表
 */
export function getMembershipList(params) {
  return request({
    url: '/admin/membership/list',
    method: 'get',
    params
  })
}

/**
 * 根据ID获取会员详情
 */
export function getMembershipById(id) {
  return request({
    url: `/admin/membership/${id}`,
    method: 'get'
  })
}

/**
 * 新增会员
 */
export function createMembership(data) {
  return request({
    url: '/admin/membership',
    method: 'post',
    data
  })
}

/**
 * 更新会员信息
 */
export function updateMembership(data) {
  return request({
    url: '/admin/membership',
    method: 'put',
    data
  })
}

/**
 * 更新会员状态
 */
export function updateMembershipStatus(id, status) {
  return request({
    url: `/admin/membership/${id}/status`,
    method: 'put',
    params: { status }
  })
}

/**
 * 会员充值（会更新会员余额）
 */
export function recharge(data) {
  return request({
    url: '/admin/membership/recharge',
    method: 'post',
    data
  })
}

/**
 * 新增充值记录（不更新会员余额）
 */
export function createRecharge(data) {
  return request({
    url: '/admin/membership/recharge/create',
    method: 'post',
    data
  })
}

/**
 * 更新充值记录
 */
export function updateRecharge(data) {
  return request({
    url: '/admin/membership/recharge',
    method: 'put',
    data
  })
}

/**
 * 获取充值记录列表
 */
export function getRechargeList(params) {
  return request({
    url: '/admin/membership/recharge/list',
    method: 'get',
    params
  })
}

/**
 * 根据ID获取充值记录详情
 */
export function getRechargeById(id) {
  return request({
    url: `/admin/membership/recharge/${id}`,
    method: 'get'
  })
}

/**
 * 充值记录申请退款
 * @param {Object} data - { id: 充值记录ID, refundAmount: 退款金额(元) }
 */
export function refundRecharge(data) {
  return request({
    url: '/admin/membership/recharge/refund',
    method: 'post',
    data
  })
}

/**
 * 检查指定类型的额度是否超限
 * @param {string} quotaType 额度类型：CUSTOMER-客户数, FOLLOW-跟进数, DEAL-成交台账数, CONTRACT-合同数, ATTACHMENT-附件数, CARD_SCAN-名片扫描次数
 * @returns {Promise} 额度使用情况
 */
export function checkQuota(quotaType) {
  return request({
    url: '/membership/check-quota',
    method: 'get',
    params: { quotaType }
  })
}

/**
 * 查询会员额度使用情况（后台系统接口）
 * @param {number} id 会员ID
 * @returns {Promise} 额度使用情况
 */
export function getMembershipQuota(id) {
  return request({
    url: `/admin/membership/${id}/quota`,
    method: 'get'
  })
}

